import mammoProtocol from './mammoProtocol.json';
import mammo2ViewProtocol from './mammo-2-views.json';

export const availableProtocols = [
  mammoProtocol,
  mammo2ViewProtocol
];

export {
  mammoProtocol,
  mammo2ViewProtocol
};
